module.exports = __webpack_public_path__ + "static/img/wedge-logo.18e2cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wedge-logo.png
// module id = 450
// module chunks = 2